import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import { StringElement } from '@swagger-api/apidom-core';
class JsonSchemaDialect extends StringElement {
  constructor(content, meta, attributes) {
    super(content, meta, attributes);
    this.element = 'jsonSchemaDialect';
  }
}
_defineProperty(JsonSchemaDialect, "default", new JsonSchemaDialect('https://spec.openapis.org/oas/3.1/dialect/base'));
export default JsonSchemaDialect;